import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import ContractGenerator from "@/pages/ContractGenerator";
export const Route = createFileRoute("/contracts")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><ContractGenerator /></ProtectedRoute>) });
